<app-navbar></app-navbar>
<main class="flex-grow-1">
  <router-outlet></router-outlet>
</main>
<app-footer></app-footer>